import { get } from 'lodash/fp'
import { Flex, Box } from 'rebass'
import styled from 'styled-components'

import createNumberInput from 'e-submission/components/Form/Input/NumberInput'

import createDropdown from './index'

const MONTHS = [
  { text: 'มกราคม', value: '0' },
  { text: 'กุมภาพันธ์', value: '1' },
  { text: 'มีนาคม', value: '2' },
  { text: 'เมษายน', value: '3' },
  { text: 'พฤษภาคม', value: '4' },
  { text: 'มิถุนายน', value: '5' },
  { text: 'กรกฎาคม', value: '6' },
  { text: 'สิงหาคม', value: '7' },
  { text: 'กันยายน', value: '8' },
  { text: 'ตุลาคม', value: '9' },
  { text: 'พฤศจิกายน', value: '10' },
  { text: 'ธันวาคม', value: '11' },
]

const BoxContainer = styled(Box)`
  & + & {
    margin-left: 0.5rem;
  }
`

const NumberInput = createNumberInput(({ value, onChange }) => {
  return {
    value,
    onChange,
  }
})
const Dropdown = createDropdown(({ value, onChange }) => {
  return {
    value,
    onChange,
  }
})

export const Component = ({ validate, setValue, value }) => {
  const month = get('month', value)
  const year = get('year', value)

  const onTextBoxChange = (month) => (year) => {
    setValue({
      year,
      month,
    })
  }

  const onDropdownChange = (year) => (month) => {
    setValue({
      year,
      month,
    })
  }
  return (
    <Flex>
      <BoxContainer flex="1 1 100%">
        <Dropdown placeHolder={'เดือน'} value={month} options={MONTHS} setValue={onDropdownChange(year)} />
      </BoxContainer>
      <BoxContainer flex="1 1 100%">
        <NumberInput
          validate={validate}
          placeholder={'ปี (พ.ศ.)'}
          format={'####'}
          value={year}
          setValue={onTextBoxChange(month)}
        />
      </BoxContainer>
    </Flex>
  )
}

export default (hoc) => Component
